import {AccountService} from '../core/services/AccountService';
export class initialize {
  public static $inject: Array<string> = ["$http", "AccountService", "$rootScope", "$location", "$window"];
  constructor($http: ng.IHttpService, account: AccountService, $rootScope: ng.IRootScopeService, $location: ng.ILocationService, $window: ng.IWindowService){
    let token = localStorage.getItem('token')
    if (token) {
      $http.defaults.headers.common = {'x-access-token': token};
      account.me();
    }
    $rootScope.$on("userLogout", () => {
      account.logout(encodeURI($location.url()));
    })
    $rootScope.$on('$stateChangeSuccess', (event, toState, toParams, fromState, fromParams, error) => {
      const path = encodeURI($location.url());
      if (path.indexOf('login') === -1 && path.indexOf('logout') === -1)
        localStorage.setItem("lastVisited", path);
    })
    $rootScope.$on('$stateChangeSuccess', (event, toState, toParams, fromState, fromParams, error) => {
      const path = encodeURI($location.url());
      if (path.indexOf('login') === -1 && path.indexOf('logout') === -1)
        localStorage.setItem("lastVisited", path);
    })
    $rootScope.$on("$stateChangeError", (event, toState, toParams, fromState, fromParams, error) => {
      $location.path("/");
    })
    $window.onbeforeunload = function() {
      localStorage.removeItem(token);
      return undefined;
    };
  }
}
